import styled, { css } from 'styled-components';
import { device } from '../../../utils/constants';

const AOS_DURATION = '1000';

/** Atributos AOS para animaciones de entrada al entrar en viewport */
export const labAos = (type = 'fade-up', delay = 0) => ({
  'data-aos': type,
  'data-aos-duration': AOS_DURATION,
  ...(delay > 0 ? { 'data-aos-delay': String(delay) } : {}),
});

/** Padding superior de sección en móvil */
export const labSectionPadMobile = css`
  @media ${device.mobile} {
    padding-top: clamp(2.5rem, 10vw, 3.5rem);
  }
`;

/** Títulos de sección (h2) */
export const labTitleMobile = css`
  @media ${device.mobile} {
    font-size: clamp(1.625rem, 7.5vw, 2.25rem);
    letter-spacing: 0.08em;
    line-height: 1.15;
  }
`;

/** Subtítulos / h3 */
export const labSubtitleMobile = css`
  @media ${device.mobile} {
    font-size: clamp(1rem, 4.5vw, 1.25rem);
    letter-spacing: 0.06em;
    line-height: 1.2;
  }
`;

/** Cuerpo de texto */
export const labBodyMobile = css`
  @media ${device.mobile} {
    font-size: clamp(0.875rem, 3.5vw, 1.0625rem);
    line-height: 1.45;
  }
`;

/** Texto pequeño (captions, meta) */
export const labCaptionMobile = css`
  @media ${device.mobile} {
    font-size: clamp(0.75rem, 3vw, 0.9375rem);
    line-height: 1.4;
  }
`;

/**
 * Línea horizontal a ancho del contenedor Body del lab.
 */
export const LabBottomRule = styled.div`
  height: 1px;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
`;

/** Divisor interno (mismo ancho que el contenido, sin compensar padding). */
export const LabRule = styled.div`
  height: 1px;
  background: #ffffff;
  width: 100%;
`;
